import React from 'react';
import {ChevronRight} from '@material-ui/icons';

export const ChevronRightIcon = () => {
  return <ChevronRight />;
};
